export const catalog_matrix = [
  {form_key:'new_public_insurance_id', catalog_key:'public_insurances'},
  //{form_key:'responsible_id', catalog_key:'none', propname:'users'},
]